import contactar_asegurado from '@/mixins/enviar_mensajes/contactar_asegurado'
export default {
	mixins: [contactar_asegurado],
}